<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YgupLM/tc-custom/9781528963510.jpg?1741375141316" alt="This image is the cover for the book Bleeding Hearts of a Butterfly"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bleeding Hearts of a Butterfly
      </h1>
      <p class="bookDescription body article font2">
        <p>“With you, I don’t like it but love it, even if it means to live in a hell. Not that a child is a hell, but in our case, it would mean the world.” “I would be a house wife and jobless,” I smile, opening my eyes. “No man should say my wife doesn’t have a job. It’s impossible for a woman not to have one. She may not sit behind a desk or get paid but she deserves a reward for everything she has and does as a woman and a wife, or a mother. Her family is her job. She takes care of them; she worries about them all day and night. So how come I’d say my lady, my love and my wife doesn’t have a job? Not especially when you are there to share the pains and joys of life with me. You’re in charge of my life; I’m your job. I will worship you in every way possible and award you in as much as I can. You’re the boss of my life, my master and I your slave. I love you, Butterfly.” “You mean, master Butterfly?” I smile big in delight. “My love lord, my wizard, I love you.” I stretch myself up and kiss him. “Get up now; you should be at work.” I get up and roll myself in the white sheet and walk to the closet to pick something for him to dress himself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mihret Adal Gidi
      </h2>
      
      <p class="authorDescription body article">Mihret Adal Gidi is a young novelist emerging from East Africa, based in Addis Ababa, Ethiopia. She is known for being a strong fighter and someone who doesn’t give up. She has always dreamt of being an author, and she was praised because of her potential by her teachers while in high school. She finally mustered up her courage to complete Bleeding Hearts of a Butterfly for publication during her study at Kotobe University College. She’s currently working on the sequel of this book and a new horror story among many others.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a9a5eef8